export default __webpack_public_path__ + "static/media/birthdayGift.5597f954.svg";